<template>
  <div>
    <BLoading :active.sync="onboarding.loadingStatus.isLoading" />
    <div v-if="!onboarding.loadingStatus.isLoading" class="ls-leads-details-view--container">
      <span class="ls-leads-details-view--heading">
        Additional job details to help a pro price your job
      </span>
      <form novalidate @submit.prevent="submit">
        <LsInput
          v-model="notes"
          label="Tell Us About The Job"
          track-id="onboarding_leads_details_view-notes"
          placeholder="Enter Notes..."
          name="notes"
          type="textarea"
          max-length="1000"
          :validation="{ required: true }"
        />
        <LsSelect
          v-model="budget"
          label="Budget"
          sub-label="(This isn't shown to pros)"
          one-line-label
          :options="onboarding.leadsDetails.budgetOptions"
          track-id="onboarding_leads_details_view-budget"
          name="budget"
          :validation="{ required: true }"
        />
        <LsRadios
          v-model="stage"
          label="Stage"
          :options="onboarding.leadsDetails.stageOptions"
          name="stage"
          track-id="onboarding_leads_details_view-stage"
          columns
          :validation="{ required: true }"
        />
        <LsUploadPhotos
          v-model="images"
          track-id="onboarding_leads_details_view-images"
          label="Upload photos"
          sub-label="(Optional)"
          one-line-label
          name="images"
        />
        <LsButton
          text="continue"
          track-id="onboarding_leads_details_view-continue"
          type="submit"
          :loading="onboarding.loadingStatus.isUpdating"
        />
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { ONBOARDING__LEADS_SUBMIT_DETAILS } from '@/store/types';
import { LsInput, LsSelect, LsRadios, LsUploadPhotos, LsButton } from '@/components/common';
import { lsValidationService } from 'ls-vue-common';
import { lsUploadPhotosHelper } from '@/helpers';

export default {
  name: 'OnboardingLeadsDetailsView',
  $_veeValidate: {
    validator: 'new',
  },
  components: {
    LsInput,
    LsSelect,
    LsRadios,
    LsUploadPhotos,
    LsButton,
  },
  data() {
    return {
      notes: '',
      budget: null,
      stage: '',
      images: [],
    };
  },
  computed: {
    ...mapState(['onboarding']),
  },
  methods: {
    ...mapActions([ONBOARDING__LEADS_SUBMIT_DETAILS]),
    async submit() {
      const isFormValid = await this.$validator.validateAll();
      const isUploadValid = lsUploadPhotosHelper.isValidUpload(this.images);

      if (!isFormValid || !isUploadValid) {
        return lsValidationService.scrollToInvalid();
      }

      this[ONBOARDING__LEADS_SUBMIT_DETAILS]({
        notes: this.notes,
        budget: this.budget,
        stage: this.stage,
        images: this.images,
      });
    },
  },
};
</script>
<style lang="scss">
.ls-leads-details-view--container {
  padding: 60px 70px 87px 70px;
  display: flex;
  flex-direction: column;

  form {
    width: 100%;
  }

  form > :not(:last-child) {
    margin-bottom: 20px !important;
  }

  .ls-leads-details-view--heading {
    font-weight: 600;
    font-size: 24px;
    color: $primary;
    text-align: center;
    margin-bottom: 5px;
  }
}

@media (max-width: $mobile-max-width) {
  .ls-leads-details-view--container {
    padding: 0 0 65px 0;

    .ls-leads-details-view--heading {
      font-size: 20px;
      color: $primary;
      text-align: center;
      margin: 0 0 10px 0;
    }
  }
}
.themed-app {
  .ls-leads-details-view--container {
    .ls-leads-details-view--heading {
      color: $theme-color-primary;
    }
  }

  @media (max-width: $mobile-max-width) {
    .ls-leads-details-view--container {
      .ls-leads-details-view--heading {
        color: $theme-color-primary;
      }
    }
  }
}
</style>
